export const SERVER_LOCATION = {
	EU: { id: 'EU', label: 'app.geolocation.europe', testId: 'europe_choice_radio_button' },
	US: { id: 'US', label: 'app.geolocation.united-states', testId: 'us_choice_radio_button' },
};
